export const SET_ACTIVE_BOOKING = 'driverOnDemand/SET_ACTIVE_BOOKING';
export const SET_PREVIOUS_BOOKING = 'driverOnDemand/SET_PREVIOUS_BOOKING';
export const SET_BOOKING_DETAILS = 'driverOnDemand/SET_BOOKING_DETAILS';
export const SET_SELECTED_VEHICLE = 'driverOnDemand/SET_SELECTED_VEHICLE';
export const SET_PICK_SLOT = 'driverOnDemand/SET_PICK_SLOT';
export const SET_SELECTED_PACKAGE = 'driverOnDemand/SET_SELECTED_PACKAGE';
export const SET_PICKUP_LOCATION = 'driverOnDemand/SET_PICKUP_LOCATION';
export const SET_DROP_LOCATION = 'driverOnDemand/SET_DROP_LOCATION';
export const SET_TRIP_TYPE = 'driverOnDemand/SET_TRIP_TYPE';
export const SET_HAS_TERMS_READ = 'driverOnDemand/SET_HAS_TERMS_READ';